import styled from 'styled-components'

import { useNoticeDetail } from '~/features/notice/queries/useNotice'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import theme from '~/shared/styles/theme'

// TODO: 임시로 52번째 공지사항 게시글 매직넘버 처리
function RatingRulePage() {
  const noticeId = '66'
  const { data, isLoading } = useNoticeDetail(noticeId)

  if (isLoading) return <LoadingScreen />

  return (
    <Wrapper>
      <Body dangerouslySetInnerHTML={{ __html: data?.info.body || '' }} />
    </Wrapper>
  )
}

export default RatingRulePage

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;

  box-sizing: border-box;
  width: 100vw;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 0 auto;
  margin-top: calc(80px + ${theme.size.headerHeight}px);
  margin-bottom: 120px;

  @media ${theme.device.medium} {
    gap: 24px;
    align-items: start;

    width: 90vw;
    height: auto;
    margin-top: calc(56px + ${theme.size.headerHeight}px);
  }
`

const Body = styled.div`
  width: 100%;
  font-family: NanumSquareNeo-Regular, sans-serif;

  img,
  video {
    max-width: 100%;
    height: auto;
  }

  table {
    width: 100%;
  }

  pre,
  code {
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  iframe {
    max-width: 100%;
  }
`
